import { useQuery } from '@tanstack/react-query';
import {  getFunctionTeachingLearning, getHomeBanner, getLearningToolsEditor, getNavigation, getServiceAIAnalyticsAssistant, getInformation, 
    getServiceAIDictationWizard, getServiceAILearningChatbot, getServiceAIMarkingWizard, getServiceAIQuizWizard, getServiceAISpeckingCoach, getServiceProduct, getMaterialLibrary, 
    getOctoDapAiCampusHub,
    getOctoDapAiCampusHubDynamic,
    getOctoDAPAIWorkplaceHub,
    getOctoDAPAIWorkplaceHubDynamic, getHomeData, getHomeToolsData, 
    getLatestUpdatesPostData,
    getNewsCategoriesData,
    getPostDetailData,
    getHomeLatestUpdatesPostData,
    getFontSizeData,
    getBusinessPartnerItem,
    getBusinessPartnerCategories,
} from './post.tsx';

export const useHomeBanner = (locale: string) => {
    return useQuery({
        queryKey: ['homeBanner', locale],
        queryFn: () => getHomeBanner(locale),
    });
};

export const useNavigation = (locale: string) => {
    return useQuery({
        queryKey: ['navigation', locale],
        queryFn: () => getNavigation(locale),
    });
};

export const useInformation = (locale: string) => {
    return useQuery({
        queryKey: ['information', locale],
        queryFn: () => getInformation(locale),
    });
};

//Product & Service
export const useServiceProduct = (locale: string) => {
    return useQuery({
        queryKey: ['serviceProduct', locale],
        queryFn: () => getServiceProduct(locale),
    });
};

export const useFunctionTeachingLearning = (locale: string) => {
    return useQuery({
        queryKey: ['functionTeachingLearning', locale],
        queryFn: () => getFunctionTeachingLearning(locale),
    });
};

export const useLearningToolsEditor = (locale: string) => {
    return useQuery({
        queryKey: ['learningToolsEditor', locale],
        queryFn: () => getLearningToolsEditor(locale),
    });
};

export const useMaterialLibrary = (locale: string) => {
    return useQuery({
        queryKey: ['materialLibrary', locale],
        queryFn: () => getMaterialLibrary(locale),
    });
};

export const useServiceAIDictationWizard = (locale: string) => {
    return useQuery({
        queryKey: ['serviceAIDictationWizard', locale],
        queryFn: () => getServiceAIDictationWizard(locale),
    });
};

export const useServiceAIAnalyticsAssistant = (locale: string) => {
    return useQuery({
        queryKey: ['serviceAIAnalyticsAssistant', locale],
        queryFn: () => getServiceAIAnalyticsAssistant(locale),
    });
};

export const useServiceAILearningChatbot = (locale: string) => {
    return useQuery({
        queryKey: ['serviceAILearningChatbot', locale],
        queryFn: () => getServiceAILearningChatbot(locale),
    });
};

export const useServiceAIMarkingWizard = (locale: string) => {
    return useQuery({
        queryKey: ['serviceAIMarkingWizard', locale],
        queryFn: () => getServiceAIMarkingWizard(locale),
    });
};

export const useServiceAISpeckingCoach = (locale: string) => {
    return useQuery({
        queryKey: ['serviceAISpeckingCoach', locale],
        queryFn: () => getServiceAISpeckingCoach(locale),
    });
};

export const useServiceAIQuizWizard = (locale: string) => {
    return useQuery({
        queryKey: ['serviceAIQuizWizard', locale],
        queryFn: () => getServiceAIQuizWizard(locale),
    });
};

export const useOctoDapAiCampusHub = (locale: string) => {
    return useQuery({
        queryKey: ['octoDapAiCampusHub', locale],
        queryFn: () => getOctoDapAiCampusHub(locale),
    });
};

export const useOctoDapAiCampusHubDynamic = (locale: string) => {
    return useQuery({
        queryKey: ['octoDapAiCampusHubDynamic', locale],
        queryFn: () => getOctoDapAiCampusHubDynamic(locale),
    });
};

export const useOctoDAPAIWorkplaceHub = (locale: string) => {
    return useQuery({
        queryKey: ['octoDAPAIWorkplaceHub', locale],
        queryFn: () => getOctoDAPAIWorkplaceHub(locale),
    });
};

export const useOctoDAPAIWorkplaceHubDynamic = (locale: string) => {
    return useQuery({
        queryKey: ['octoDAPAIWorkplaceHubDynamic', locale],
        queryFn: () => getOctoDAPAIWorkplaceHubDynamic(locale),
    });
};

export const useHomeData = (locale: string) => {
    return useQuery({
        queryKey: ['homeData', locale],
        queryFn: () => getHomeData(locale),
    });
};

export const useHomeToolsData = (locale: string) => {
    return useQuery({
        queryKey: ['homeToolsData', locale],
        queryFn: () => getHomeToolsData(locale),
    });
};

export const useLatestUpdatesPostData = (locale: string) => {
    return useQuery({
        queryKey: ['latestUpdatesPostData', locale],
        queryFn: () => getLatestUpdatesPostData(locale),
    });
};

export const usePostDetailData = (locale: string, id: number) => {
    return useQuery({
        queryKey: ['postDetailData', locale, id],
        queryFn: () => getPostDetailData(locale, id),
    });
};

export const useHomeLatestUpdatesPostData = (locale: string) => {
    return useQuery({
        queryKey: ['homeLatestUpdatesPostData', locale],
        queryFn: () => getHomeLatestUpdatesPostData(locale),
    });
};

export const useNewsCategoriesData = () => {
    return useQuery({
        queryKey: ['newsCategoriesData'],
        queryFn: () => getNewsCategoriesData(),
    });
};

export const useFontSizeData = (locale: string) => {
    return useQuery({
        queryKey: ['fontSizeData', locale],
        queryFn: () => getFontSizeData(locale),
    });
};

export const useBusinessPartnerItem = (locale: string) => {
    return useQuery({
        queryKey: ['businessPartner', locale],
        queryFn: () => getBusinessPartnerItem(locale),
    });
};

export const useBusinessPartnerCategories = () => {
    return useQuery({
        queryKey: ['businessPartnerCategories'],
        queryFn: () => getBusinessPartnerCategories(),
    });
};